export default {
  victimology: {
    attacked_regions: 'Attacked Regions',
    attacked_countries: 'Attacked Countries',
    attacked_sectors: 'Attacked Sectors',
    table: {
      header: {
        company: 'Company',
        sector: 'Sector',
        country: 'Country',
        attack_date: 'Attack Date'
      }
    },
    filters: {
      title: 'Filters',
      region: 'Region',
      country: 'Country',
      sector: 'Sector',
      organization: 'Organization',
      clear_filters: 'Clear Filters',
      clear_all: 'Clear All',
      apply: 'Apply'
    }
  },
  common: {
    no_items_to_show: 'No items to show'
  }
};
